export default __webpack_public_path__ + "static/media/gn.ea1b6b3e.svg";